/**
 * Regeln der Spaltenfilter – ohne Oberflaeche.
 *
 * Bewusst getrennt von der Komponente: Die Frage "findet 'muller' auch
 * 'Müller'?" ist eine Aussage ueber den Vergleich. Sie laesst sich so ohne
 * Browser und ohne Fluent pruefen, und die Komponente kann sich auf die
 * Darstellung beschraenken.
 */
/**
 * Eine filterbare Spalte.
 *
 * `get` liefert den Text, gegen den verglichen wird – nicht zwingend das, was
 * in der Zelle steht. Eine Zelle mit Abzeichen etwa liefert die aneinander
 * gehaengten Beschriftungen, damit auch danach gesucht werden kann.
 * `null` bedeutet "kein Wert"; solche Zeilen fallen bei einem gesetzten
 * Filter heraus.
 */
export interface FilterColumn<T> {
  key: string;
  get: (row: T) => string | number | null | undefined;
  /** Spalte ohne Filter (z. B. Aktionen): belegt nur den Platz. */
  disabled?: boolean;
  /** Eigene Beschriftung fuer Vorlesewerkzeuge; sonst der Spaltenschluessel. */
  label?: string;
}

/** Vergleichsform: klein, ohne Akzente, ohne Randleerraum. */
export function normalizeForFilter(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '';
  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

/**
 * Die eigentliche Filterung – bewusst als freie Funktion, damit sie ohne
 * React geprueft werden kann.
 *
 * Mehrere gefuellte Felder schraenken ein (UND), sie erweitern nicht. Das ist
 * die Erwartung an eine Filterzeile: Wer Land "Deutschland" und Abteilung
 * "Treasury" tippt, will beides gleichzeitig.
 */
export function filterRows<T>(
  rows: readonly T[],
  columns: readonly FilterColumn<T>[],
  values: Record<string, string>,
): T[] {
  const gesetzt = columns
    .filter((c) => !c.disabled && normalizeForFilter(values[c.key]) !== '')
    .map((c) => ({ get: c.get, needle: normalizeForFilter(values[c.key]) }));
  if (gesetzt.length === 0) return [...rows];
  return rows.filter((row) => gesetzt.every((f) => normalizeForFilter(f.get(row)).includes(f.needle)));
}
